/* eslint-disable import/no-cycle */
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { momentConstants } from '../../../../../constants'

const useController = (props) => {
  const { setData, document } = props
  const { t } = useTranslation()
  const [inputs, setInputs] = useState({
    date: '',
    number: '',
    DateOfIncreased: '',
    time: '',
    raison: '',
    effect: '',
    description: '',
    address: '',
    amountMinor: '',
    amountNormal: '',
    amountIncreased: '',
  })
  const {
    date,
    DateOfIncreased,
    time,
    raison,
    number,
    description,
    address,
    effect,
    amountMinor,
    amountNormal,
    amountIncreased,
  } = inputs

  const handleChange = useCallback((e) => {
    const { name, value } = e.target
    setInputs((i) => ({ ...i, [name]: value }))
  }, [])

  useEffect(() => {
    const abortController = new AbortController()
    const setInputsValue = () => {
      setData({
        date,
        DateOfIncreased,
        time,
        number,
        raison,
        description,
        effect,
        address,
        amountNormal,
        amountMinor,
        amountIncreased,
      })
    }
    setInputsValue()
    return () => {
      abortController.abort()
    }
  }, [
    date,
    DateOfIncreased,
    time,
    number,
    raison,
    description,
    effect,
    address,
    amountNormal,
    amountMinor,
    amountIncreased,
    setData,
  ])

  useEffect(() => {
    const abortController = new AbortController()
    const setDoc = async () => {
      if (document && document.data) {
        setInputs({
          raison: document.data.raison || '',
          description: document.data.description || '',
          amountMinor: document.data.amountMinor || '',
          amountNormal: document.data.amountNormal || '',
          amountIncreased: document.data.amountIncreased || '',
          effect: document.data.effect || '',
          number: document.data.number || '',
          address: document.data.address || '',
          date:
            moment(document.data.date).format(
              momentConstants.FORMAT_text_field,
            ) || '',
          DateOfIncreased:
            moment(document.data.DateOfIncreased).format(
              momentConstants.FORMAT_text_field,
            ) || '',
          time: document.data.time || '',
        })
      }
    }
    setDoc()
    return () => {
      abortController.abort()
    }
  }, [document])

  return {
    t,
    handleChange,
    number,
    raison,
    description,
    address,
    amountMinor,
    amountNormal,
    amountIncreased,
    date,
    DateOfIncreased,
    time,
    effect,
  }
}
export default useController
